import type { FC } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'
import { useSite } from '@/components/generals/site-context'

import { siteConfig } from '@/constants/site'

const COLUMNS = [
    {
        title: 'Discover',
        links: [
            { href: '/jobs', label: 'Explore jobs' },
            { href: '/jobs?work=remote', label: 'Remote jobs' },
            { href: '/companies', label: 'Companies' }
        ]
    },
    {
        title: 'Your career',
        links: [
            { href: '/resumes', label: 'Resume builder' },
            { href: '/matches', label: 'Job matches' },
            { href: '/applications', label: 'Application tracker' }
        ]
    },
    {
        title: 'TechJobs',
        links: [
            { href: '/privacy', label: 'Privacy' },
            { href: '/terms', label: 'Terms of use' },
            { href: '/signup', label: 'Create an account' }
        ]
    }
]

export const Footer: FC = () => {
    const { now } = useSite()
    const year = now ? new Date(now).getUTCFullYear() : 2026

    return (
        <footer className='border-t border-border/70 bg-card'>
            <div className='container-page grid gap-10 py-14 md:grid-cols-[1.4fr_repeat(3,1fr)]'>
                <div className='flex flex-col gap-4'>
                    <Logo />
                    <p className='max-w-xs text-sm leading-relaxed text-muted-foreground'>
                        {siteConfig.description}
                    </p>
                </div>

                {COLUMNS.map(column => (
                    <div key={column.title} className='flex flex-col gap-3'>
                        <h2 className='text-sm font-semibold text-foreground'>{column.title}</h2>
                        <ul className='flex flex-col gap-2.5'>
                            {column.links.map(link => (
                                <li key={link.href}>
                                    <Link href={link.href} className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className='border-t border-border/70'>
                <div className='container-page flex flex-col gap-2 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
                    <p>© {year} {siteConfig.name}. Jobs are collected from public company career pages, and you always apply on the employer&apos;s own site.</p>
                    <p>Built for people who build technology.</p>
                </div>
            </div>
        </footer>
    )
}
